import React from 'react';
import type helpCenterSettingsCustomerNotificationsType from '@atlassian/jira-spa-apps-help-center-settings-customer-notifications/src/index.tsx';
import { markAsProductBundleReady } from '@atlassian/jira-spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

export const LazyHelpCenterSettingsCustomerNotifications = lazyForPaint<
	typeof helpCenterSettingsCustomerNotificationsType
>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-help-center-settings-customer-notifications", jiraSpaEntry: "async-help-center-settings-customer-notifications" */ '@atlassian/jira-spa-apps-help-center-settings-customer-notifications'
		),
	),
);

export const HelpCenterSettingsCustomerNotifications = (): React.JSX.Element => (
	<LazyPage
		Page={LazyHelpCenterSettingsCustomerNotifications}
		pageId="help-center-settings-customer-notifications"
		shouldShowSpinner
	/>
);
